import React from 'react';
import { Chip } from '@mui/material';

export const formatValue = (value, formatter, isSubmitting) => {
    if (value !== null && value !== undefined) {
        return formatter(value);
    }
    return isSubmitting ? '...' : '—';
};

export const toAbsolute = (logValue) => {
    const n = Number(logValue);
    return logValue === null || logValue === undefined || Number.isNaN(n)
        ? null
        : Math.pow(10, n);
};

export const fmtLog = (v) =>
    v == null || Number.isNaN(Number(v)) ? '—' : Number(v).toFixed(2);

export const fmtAbs = (logValue) => {
    const abs = toAbsolute(logValue);
    return abs === null
        ? '—'
        : abs.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
          });
};

export const fmtAbsWithLog = (logValue) => {
    if (
        logValue === null ||
        logValue === undefined ||
        Number.isNaN(Number(logValue))
    ) {
        return '—';
    }
    const abs = toAbsolute(logValue);
    const absStr = abs.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const logStr = Number(logValue).toFixed(2);
    return `${absStr} (${logStr})`;
};

/**
 * Diferença modelo − laboratório em log10. A régua é uma só no CRM (diálogo de
 * Processar e detalhe da amostra): até 0,3 log concorda, até 0,7 pede atenção, acima
 * diverge.
 */
export const LIMITES_DELTA_LOG = Object.freeze({ atencao: 0.3, erro: 0.7 });

export const corDeltaLog = (delta) => {
    const abs = Math.abs(delta);
    if (abs > LIMITES_DELTA_LOG.erro) return 'error';
    if (abs > LIMITES_DELTA_LOG.atencao) return 'warning';
    return 'success';
};

export const getDeltaChip = (predictLog, labLog, isSubmitting) => {
    if (isSubmitting) return <Chip size="small" label="..." />;
    const p = Number(predictLog);
    const l = Number(labLog);
    if (
        predictLog == null ||
        Number.isNaN(p) ||
        labLog == null ||
        Number.isNaN(l)
    ) {
        return <Chip size="small" label="N/A" variant="outlined" />;
    }
    const delta = p - l;
    const label = `${delta > 0 ? '+' : ''}${delta.toFixed(2)}`;
    return <Chip size="small" label={label} color={corDeltaLog(delta)} />;
};
